import { Box, styled } from '@mui/material';

export const CanvasContainerBlock = styled(Box)(({ theme }) => ({
  // '*': {
  //   maxWidth: '100%',
  // },
  // [theme.breakpoints.up(991)]: {
  //   width: 'calc(100% - 330px)',
  // },
}));
